// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* remove all prev styles from container */\n.email-container {\n  margin: 10px 0;\n  min-height: initial;\n  font-size: 15px;\n  padding: 10px;\n  background-color: #fff;\n  border: 1px solid #b7b7b7;\n  font-family: sans-serif;\n  color: black;\n}\n\n/* reset CSS in email preview */\n.email-container p {\n  display: block;\n  font-size: initial;\n  line-height: initial;\n  margin: initial;\n  padding: 3px;\n}", ""]);
// Exports
module.exports = exports;
